import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { COLOR_MODE_KEY, ColorMode } from './color-mode';

export const provideColorMode = (storageKey: string): EnvironmentProviders =>
  makeEnvironmentProviders([{ provide: COLOR_MODE_KEY, useValue: storageKey }, ColorMode]);
